module.exports = __webpack_public_path__ + "img/AS0770027.feb7c5f4.jpg";